import { createContext, ReactNode, useContext, useState } from "react";

interface CepContextType {
    cep: string
    changeCep: (cep: string) => void
    isComplete: () => boolean
}

export const CepContext = createContext<CepContextType | undefined>(undefined)

interface CepProviderProps {
    children: ReactNode
}

export function CepProvider({ children }: CepProviderProps) {
    const [cep, setCep] = useState<string>('')

    function changeCep(cep: string) {
        setCep(cep)
    }

    function isComplete() {
        if(cep.replace('-', '').length === 8)
            return true
        return false
    }

    return (
        <CepContext.Provider value={{ cep, changeCep, isComplete }}>
            {children}
        </ CepContext.Provider>
    )
}

export function useCep(){
    const context = useContext(CepContext)
    if (!context) {
        throw new Error('Header deve estar dentro do CepProvider');
    }
    return context
}
